
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"hideColumn":"Spalte ausblenden","hideHierarchy":"Hierarchie ausblenden"},"en":{"hideColumn":"Hide column","hideHierarchy":"Hide hierarchy"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();